/**
 * Auth-only Supabase client for the /web frontend.
 *
 * This client is used EXCLUSIVELY for:
 *   1. supabase.auth.signInAnonymously()     — guest anonymous login
 *   2. supabase.auth.signInWithPassword()    — email/password login
 *   3. supabase.auth.signInWithOAuth()       — Google / Apple login
 *   4. supabase.auth.signUp()                — registration
 *   5. supabase.auth.signOut()
 *   6. supabase.auth.getSession()            — get JWT for API calls
 *   7. supabase.auth.onAuthStateChange()     — react to session changes
 *
 * ALL DATA OPERATIONS must go through VITE_API_URL (/api server).
 * Do NOT use this client to query Supabase tables directly.
 */
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
